const EMPTY_ARRAY: readonly never[] = Object.freeze([]);

export default EMPTY_ARRAY;
